"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = exports.VEHICLE_SELECTOR_QUERY = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireDefault(require("react"));
var _commonLoader = require("@mmc/common-loader");
var _reactRedux = require("react-redux");
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _reactApollo = require("react-apollo");
var _templateObject, _CommonLoader, _p;
var VEHICLE_SELECTOR_QUERY = (0, _graphqlTag["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2["default"])(["\n  query ContentPage($market: String!, $language: String!, $path: String) {\n    ContentPage(market: $market, lang: $language, path: $path) {\n      components {\n        ... on MultiVehiclesSelector {\n          resourceType\n          locale\n          zipCodeEnabled\n          zipCodeHeadingText\n          zipCodeLabel\n          zipCodeErrorMsg\n          zipCode {\n            validationRegEx\n          }\n          msrpPrefix\n          msrpDisclaimerNo\n          modelYearLabel\n          modelYear {\n            year\n            id\n          }\n          modelNotAvailableMsg\n          vehicleCheckboxEnabled\n          vehicles {\n            vehicleName\n            vehicleCode\n            vehicleYear\n            imagePath\n            imageAltText\n            MSRP\n            isActive\n            price {\n              value\n              displayValue\n              zeroMessage\n            }\n          }\n          ctaEnabled\n          ctaLabel\n          ctaRedirectLink\n          paymentCalculatorRedirectLink\n          collapseStatus\n          disclaimerLabel\n          disclaimerList {\n            disclaimerNumber\n            disclaimerContent\n            associated\n          }\n          customizedLabel\n        }\n      }\n    }\n  }\n"])));
exports.VEHICLE_SELECTOR_QUERY = VEHICLE_SELECTOR_QUERY;
var VehicleSelectorGraphQL = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(VehicleSelectorGraphQL, _React$PureComponent);
  function VehicleSelectorGraphQL() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  var _proto = VehicleSelectorGraphQL.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      market = _this$props.market,
      language = _this$props.language,
      resourceType = _this$props.resourceType,
      path = _this$props.path;
    var variables = {
      path: path,
      market: market,
      language: language
    };
    return /*#__PURE__*/_react["default"].createElement(_reactApollo.Query, {
      query: VEHICLE_SELECTOR_QUERY,
      variables: variables
    }, function (_ref) {
      var loading = _ref.loading,
        data = _ref.data;
      if (loading) {
        return _CommonLoader || (_CommonLoader = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null));
      }
      if (data && data.ContentPage) {
        var componentData = data.ContentPage.components.find(function (c) {
          return c.resourceType === resourceType;
        });
        return /*#__PURE__*/_react["default"].cloneElement(children, {
          data: componentData
        });
      }
      return _p || (_p = /*#__PURE__*/_react["default"].createElement("p", null));
    });
  };
  return VehicleSelectorGraphQL;
}(_react["default"].PureComponent);
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    language: props.language || state.Config.language,
    market: props.market || state.Config.market,
    path: props.path || state.Config.path
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(VehicleSelectorGraphQL);
exports["default"] = _default;